/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-09 18:58:30
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-18 17:42:39
 */
import React from 'react';
import { SFCAvatar, IconFont } from '@src/features/common';
import './SFCGroupInfo.less';
import { NavLink } from 'react-router-dom';

export interface ISFCGroupInfoProps {
  /** 头像 */
  avatar: string;
  /** 团队名称 */
  groupName: string;
  /** 成员数量 */
  member: number;
  /** 团队id */
  id: number;
  /** 是团队还是圈子 */
  group?: boolean;
  /** 文章or问答 */
  article?: boolean;
  /** 文章或者问答数量 */
  number: number;
}
type Props = ISFCGroupInfoProps;

export function SFCGroupInfo(props: Readonly<Props>) {
  const { avatar, groupName, member, group = true, id, article = true, number } = props;
  return (
    <div className="common-presenter k-home-group-info">
      <NavLink to={group ? `/group/home-page/${id}` : `/team/home-page/${id}`} target="_blank">
        <SFCAvatar className={'group-avatar'} src={avatar} />
        <div className="group-info">
          <h3>{groupName}</h3>
          <p>
            <IconFont type="icon-peo" className="info-icon" />
            <span className="number">
              {member}&nbsp;
              {group ? '个成员' : '个粉丝'}
            </span>
          </p>
        </div>
      </NavLink>
    </div>
  );
}

export default SFCGroupInfo;
